var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "move-in-company" }, [
    _c(
      "div",
      { staticClass: "move-in-company__filters" },
      [
        _c("c-input", {
          ref: "moveInCompanyPeriod",
          staticClass: "move-in-company__filters__period",
          attrs: {
            label: "За период",
            placeholder: "00.00.0000 - 00.00.0000",
            type: "period",
            icon: "calendar",
            clearable: true,
            "icon-right": true,
          },
          model: {
            value: _vm.periodLocal,
            callback: function ($$v) {
              _vm.periodLocal = $$v
            },
            expression: "periodLocal",
          },
        }),
        _c(
          "div",
          { staticClass: "move-in-company__filters__block" },
          [
            _c("c-button", {
              staticClass: "move-in-company__filters__block__button",
              attrs: { label: "Применить", color: "primary" },
              on: { click: _vm.applyFilters },
            }),
            _c("c-switcher", {
              staticClass: "move-in-company__filters__block__switcher",
              attrs: { label: "Группировать по должностям" },
              model: {
                value: _vm.isGroupedTable,
                callback: function ($$v) {
                  _vm.isGroupedTable = $$v
                },
                expression: "isGroupedTable",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "move-in-company__table" },
      [
        !_vm.isTableLoading
          ? _c("c-data-table-personal-employee", {
              ref: "table",
              attrs: {
                id: "moveInCompany",
                "sorted-column": _vm.tableData.sortedColumn,
                levels: 1,
                "empty-records-label": "Записи не найдены",
                "disabled-columns": [],
                data: _vm.tableData,
              },
              on: { sortedEvent: _vm.refreshTable },
            })
          : _vm._e(),
        _vm.isTableLoading
          ? _c("c-loader", {
              staticClass: "move-in-company__table__loader",
              attrs: {
                label: "Данные загружаются",
                active: _vm.isTableLoading,
                height: "200",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }